// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + {"636":"landing","696":"promo","753":"project-preview","967":"protocol"}[chunkId] + "." + {"636":"603a05fd","696":"d97f261a","753":"8368b9d9","967":"b3d1ed00"}[chunkId] + ".js";
};